import React from 'react';
import axios from 'axios';
import { Form } from 'semantic-ui-react';
import Filters from './Filters';

export default class ReportTypeTemplate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            enableFilters: false,

            reports: [],
            report: '',
            reportName: ''
        };

        this.fetchReports = this.fetchReports.bind(this);
    }

    componentWillMount() {
        this.fetchReports(this.props.reportTypeId);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({ loading: true });
        let { reportTypeId } = nextProps;
        this.fetchReports(reportTypeId);
    }

    fetchReports(reportTypeId) {
        axios.get(`/report/${reportTypeId}/`)
            .then(res => {
                this.setState({
                    reports: res.data.map(el => ({
                        key: el.id, value: el.id, text: el.name
                    }))
                });
            }).catch(err => {
                console.log('Failed to fetch reports!');
            });
    }

    render() {
        const { enableFilters } = this.state;

        return (
            <div>
                <Form>
                    <Form.Group widths="equal">
                        <Form.Field>
                            {/* eslint-disable-next-line jsx-a11y/label-has-for */}
                            <label>Vrsta izvještaja</label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odaberite vrstu izvještaja"
                                value={this.state.report.text}
                                onChange={
                                    (e, { value }) => {
                                        this.setState({
                                            report: value,
                                            reportName: e.target.textContent,
                                            enableFilters: true
                                        });
                                    }
                                }
                                name="report"
                                options={this.state.reports}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                        <Form.Field />
                    </Form.Group>
                </Form>
                {enableFilters &&
                    <Filters
                        report={this.state.report}
                        reportTypeId={this.props.reportTypeId}
                        reportName={this.state.reportName}
                    />
                }
                {/* <Grid columns={2} centered className="stackable"> */}
                {/*    <Grid.Row stretched> */}
                {/*        <Grid.Column width={12}> */}
                {/*            {enableFilters && <Filters report={this.state.report} />} */}
                {/*        </Grid.Column> */}
                {/*        /!*<Grid.Column width={4}>*!/ */}
                {/*        /!*    {enableFilters && <AdditionalInfo report={this.state.report} />}*!/ */}
                {/*        /!*</Grid.Column>*!/ */}
                {/*    </Grid.Row> */}
                {/* </Grid> */}
                {/* <br /> */}
                {/* {enableFilters && */}
                {/*    <Grid columns={4}> */}
                {/*        <Grid.Row stretched> */}
                {/*            <br /> */}
                {/*            <Grid.Column width={1}> */}
                {/*            </Grid.Column> */}
                {/*            <Grid.Column width={7}> */}
                {/*                <Button className="ui fluid button" color="blue" onClick> */}
                {/*                    <Icon name="table" /> */}
                {/*                    Izvještaj /!* ili Tabelarni prikaz? *!/ */}
                {/*                </Button> */}
                {/*            </Grid.Column> */}
                {/*            <Grid.Column width={7}> */}
                {/*                <Button className="ui fluid button" color="green" onClick> */}
                {/*                    <Icon name="download" /> */}
                {/*                    Štampanje izvještaja */}
                {/*                </Button> */}
                {/*            </Grid.Column> */}
                {/*            <Grid.Column width={1}> */}
                {/*            </Grid.Column> */}
                {/*            <br /> */}
                {/*        </Grid.Row> */}
                {/*    </Grid> */}
                {/* } */}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/Reports/ReportTypeTemplate.js